import React from 'react';

export default class CommercialPackageZones extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      option1: null,
      geography: [],
      selectedZone: null,
      selectedState: null
    };
  }

  selectState(selectedState) {
    this.setState({
      selectedState: selectedState.key,
      option1: selectedState.title
    });
  }

  /* istanbul ignore next */
  selectArea(city, state) {
    this.props.onAreaSelect(city, state);
    this.setState({
      selectedState: null,
      option1: null
    });
  }

  setZonesCityState(selectedGeography) {
    let geography = [];

    for (let state in this.props.geography) {
      let zones = [];
      let cities = this.props.geography[state].cities;
      for (let city in cities) {
        if (cities[city].package.hasOwnProperty(this.props.packageKey)) {
          zones.push({
            cityName: cities[city].city_name,
            key: cities[city].key,
            price: cities[city].package[this.props.packageKey].base_price
          });
        }
      }
      geography.push({
        title: this.props.geography[state].state_name,
        key: state,
        cities: zones
      });
    }

    if (selectedGeography) {
      for (let selectedGeographyItem of selectedGeography) {
        for (let geographyItem of geography) {
          for (let city of geographyItem.cities) {
            if (
              selectedGeographyItem.location.city ===
              city.key
            ) {
              let index = geographyItem.cities.indexOf(city);
              if (index > -1) {
                geographyItem.cities.splice(index, 1);
              }
            }
          }
        }
      }
    }

    this.setState({
      geography: geography
    });
  }

  componentDidMount() {
    //get cities based on package selected
    this.setZonesCityState(this.props.selectedGeography);
  }

  /* istanbul ignore next */
  componentDidUpdate(prevProps) {
    const addedItemChanged = prevProps.addedItem !== this.props.addedItem && this.props.addedItem;
    const geographyChanged =
      prevProps.geography !== this.props.geography ||
      prevProps.selectedGeography !== this.props.selectedGeography;

    if (addedItemChanged) {
      this.setState({
        option1: null
      });
    }

    if (addedItemChanged || geographyChanged) {
      this.setZonesCityState(this.props.selectedGeography);
    }
  }

  render() {
    const legacySelectStyle = {
      border: '1px solid #a805fb',
      backgroundColor: '#f7efe2',
      color: 'midnightblue'
    };

    return (
      <div className='panel-body-spacing'>
        <div className='alert'>
          <div className='row body no-margin'>
            <div className='col-sm-12 no-padding'>
              <div className='product-config-select-wrap'>
                <select
                  id='areas'
                  className='form-control body'
                  style={legacySelectStyle}
                  value={this.state.selectedState || ''}
                  onChange={(event) => {
                    const selectedKey = event.target.value;
                    const selectedState = this.state.geography.find((state) => state.key === selectedKey);
                    if (selectedState) {
                      this.selectState(selectedState);
                    }
                  }}
                >
                  <option value=''>Select State</option>
                  {this.state.geography.map(function (state, index) {
                    if (state.cities.length > 0) {
                      return (
                        <option key={index} value={state.key}>
                          {state.title}
                        </option>
                      );
                    }
                    return null;
                  })}
                </select>
                <span className='caret product-config-caret'></span>
              </div>
            </div>
          </div>
        </div>
        {this.state.selectedState && (
          <div>
            {this.state.geography.map(function (state, cityIndex) {
              return (
                <div key={cityIndex}>
                  {state.key === this.state.selectedState && (
                    <div>
                      {state.cities.map(function (city, subIndex) {
                        return (
                          <div
                            className='row area-tiles pointer'
                            key={subIndex}
                            onClick={() => {
                              this.selectArea(city.key, state.key);
                            }}
                          >
                            <div className='col-xs-8 body'>{city.cityName}</div>
                            <div className='col-xs-4 body text-right'>
                              <span>${city.price.toFixed(2)}</span>
                            </div>
                          </div>
                        );
                      }, this)}
                    </div>
                  )}
                </div>
              );
            }, this)}
          </div>
        )}
        {this.props.productQuote?.lineItems?.length > 0 && (
          <div className='body margin-bottom-10 margin-top-20' >
            Selected Regions ({this.props.numberOfRegions})
          </div>
        )}
        {this.props.productQuote?.lineItems?.map(function (lineItem, index) {
          if (lineItem.description.includes("Additional Users")) return
          return (
            <div className='row area-tiles pointer' key={index}>
              <div className='col-xs-7'>
                <p className='body no-margin'>{lineItem.description}</p>
              </div>
              <div className='col-xs-5 text-right'>
                <span className='body no-margin margin-right-5'>
                  ${lineItem.total.toFixed(2)}
                </span>
                <i
                  className='fas fa-times pointer grey-text'
                  aria-hidden='true'
                  onClick={() => {
                    this.props.onRemoveCommercialGeographyPackage(lineItem, index);
                  }}
                />
              </div>
            </div>
          );
        }, this)}
      </div>
    );
  }
}
